import api from 'services/api';
import ReactGA from 'react-ga4';

export type BuildingDocumentationResponse = {
  uuid: string;
  role_type: string;
  building_uuid: string;
  account_uuid: string;
  staff_information: string;
  guest_information: string;
  vector_store_id: string;
  file_id: string;
};

export type SetBuildingDocumentationRequest = {
  building_uuid: string;
  staff_information: string;
  guest_information: string;
};

const getBuildingDocumentation = async (buildingUuid: string) => {
  const response = await api.get<BuildingDocumentationResponse>(
    `/v2/api/admin/chatbot_doc/${buildingUuid}`
  );
  return response?.data;
};

const setBuildingDocumentation = async (payload: SetBuildingDocumentationRequest) => {
  ReactGA.event({
    category: 'User',
    action: 'Set AI Building Documentation',
    label: `Building Uuid: ${payload.building_uuid}`
  });
  const response = await api.post<string>('/v2/api/admin/chatbot_doc', payload);
  return response?.data;
};

const AIAssistantService = {
  getBuildingDocumentation,
  setBuildingDocumentation
};

export default AIAssistantService;
